
import { StockAlertDto, CreateStockAlertDto, UpdateStockAlertDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { stockAlertService, StockAlertsFilters } from '@services/StockAlertService'

const { reducer, actions, thunks } = baseCrudReducer<
  StockAlertDto,
  CreateStockAlertDto,
  UpdateStockAlertDto,
  StockAlertsFilters
>('stockAlert', stockAlertService)

export default reducer

export const { setFilters: setStockAlertFilters } = actions

export const {
  getAll: getStockAlerts,
  create: createStockAlert,
  update: updateStockAlert,
  remove: removeStockAlert,
} = thunks
